module.exports = __webpack_public_path__ + "img/serie-c.dd789fda.png";